export const FormField = {
  controlledBy: 'controlledBy',
  peoPayrollProvider: 'peoPayrollProvider',
  keepOwnRevenueShare: 'keepOwnRevenueShare',
} as const;
